import { render, staticRenderFns } from "./userChoice.vue?vue&type=template&id=4f31ed70&scoped=true"
import script from "./userChoice.vue?vue&type=script&lang=js"
export * from "./userChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f31ed70",
  null
  
)

export default component.exports